import clsx from 'clsx';
import { useDispatch, useSelector } from 'react-redux';
import React, { useEffect } from 'react';
import { makeStyles } from '@mui/styles';
import { Page, Header, Alert } from 'components';
import { Grid, Button, Card, CardContent, CardHeader, Divider } from '@mui/material';
import _ from 'underscore';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import FileDownloadIcon from '@mui/icons-material/FileDownload';

import CommissioningPlanTable from './components/CommissioningPlanTable';
import CommissioningPlanImportModal from './components/CommissioningPlanImportModal';

import { GetLastImport, GetCommissioningPlanTable, GetCommissioningPlanExport, ToggleImportModalVisibility } from '../actions/CommissioningPlanActions.js';

const useStyles = makeStyles((theme) => ({
	root: {
		padding: theme.spacing(3),
	},
	container: {
		marginTop: theme.spacing(3),
	}
}));

const CommissioningPlan = () => {
	const classes = useStyles();
	const dispatch = useDispatch();
	const lastImport = useSelector((state) => state.commissioningPlanReducer.lastImport);
	const commissioningPlanTableData = useSelector((state) => state.commissioningPlanReducer.commissioningPlanTableData);
	const importModalVisibility = useSelector((state) => state.commissioningPlanReducer.importModalVisibility);

	const _onImportClick = () => {
		dispatch(ToggleImportModalVisibility(true));
	};

	const _onCloseImportModal = () => {
		dispatch(ToggleImportModalVisibility(false));
	};

	const _onExportClick = () => {
		dispatch(GetCommissioningPlanExport());
	};

	useEffect(() => {
		dispatch(GetLastImport());
		dispatch(GetCommissioningPlanTable());
	}, []);

	return (
		<Page className={classes.root} title="Tracking">
			<Header module="Tracking" view="Commissioning Plan" />
			<Alert
				className={classes.container}
				variant="info"
				message={_.isUndefined(lastImport) ? 'Last import unavailable!' : lastImport}
			/>
			<br />
			<Grid container spacing={2}>
				<Grid item lg={12} xs={12}>
					<Button
						className={classes.agreeButton}
						color="primary"
						variant="contained"
						size="medium"
						startIcon={<FileUploadIcon />}
						onClick={_onImportClick}
					>
						Import
					</Button>
					<Button
						className={classes.agreeButton}
						color="success"
						variant="contained"
						size="medium"
						startIcon={<FileDownloadIcon />}
						onClick={_onExportClick}
					>
						Export
					</Button>
				</Grid>
			</Grid>
			<br />
			<Grid item lg={12} xs={12}>
				<CommissioningPlanTable className={classes.results} data={commissioningPlanTableData} />
			</Grid>
			<Grid className={classes.container} container spacing={3}>
				<Grid item lg={12} xs={12}>
					{importModalVisibility && (
						<CommissioningPlanImportModal
							onClose={_onCloseImportModal}
							open={importModalVisibility}
						/>
					)}
				</Grid>
			</Grid>
		</Page>
	);
};

export default CommissioningPlan;
